const BOLSA = {
    99: { id: '99', descricao: 'OUTROS' },
    A0: { id: 'A0', descricao: 'B3' },
    A1: { id: 'A1', descricao: 'AMERICAN STOCK EXCHANGE' },
    A10: { id: 'A10', descricao: 'INTERNATIONAL SECURITIES EXCHANGE - ISE' },
    A11: { id: 'A11', descricao: 'NASDAQ STOCK MARKET' },
    A12: { id: 'A12', descricao: 'NYSE EURONEXT' },
    A13: { id: 'A13', descricao: 'TSX GROUP' },
    A2: { id: 'A2', descricao: 'BERMUDA STOCK EXCHANGE' },
    A3: { id: 'A3', descricao: 'BOLSA DE COMERCIO DE BUENOS AIRES' },
    A4: { id: 'A4', descricao: 'BOLSA DE COMERCIO DE SANTIAGO' },
    A5: { id: 'A5', descricao: 'BOLSA DE VALORES DE COLOMBIA' },
    A6: { id: 'A6', descricao: 'BOLSA DE VALORES DE LIMA' },
    A7: { id: 'A7', descricao: 'BOLSA MEXICANA DE VALORES' },
    A8: { id: 'A8', descricao: 'BOURSE DE MONTRÉAL' },
    A9: { id: 'A9', descricao: 'CHICAGO BOARD OPTIONS EXCHANGE' },
    C1: { id: 'C1', descricao: 'AUSTRALIAN SECURITIES EXCHANGE' },
    C10: { id: 'C10', descricao: 'OSAKA SECURITIES EXCHANGE' },
    C11: { id: 'C11', descricao: 'PHILIPPINE STOCK EXCHANGE' },
    C12: { id: 'C12', descricao: 'SHANGHAI STOCK EXCHANGE' },
    C13: { id: 'C13', descricao: 'SHENZHEN STOCK EXCHANGE' },
    C14: { id: 'C14', descricao: 'SINGAPORE EXCHANGE' },
    C15: { id: 'C15', descricao: 'STOCK EXCHANGE OF TEHRAN' },
    C16: { id: 'C16', descricao: 'STOCK EXCHANGE OF THAILAND' },
    C17: { id: 'C17', descricao: 'TAIWAN STOCK EXCHANGE' },
    C18: { id: 'C18', descricao: 'TOKYO STOCK EXCHANGE' },
    C2: { id: 'C2', descricao: 'BOMBAY STOCK EXCHANGE' },
    C3: { id: 'C3', descricao: 'BURSA MALAYSIA' },
    C4: { id: 'C4', descricao: 'COLOMBO STOCK EXCHANGE' },
    C5: { id: 'C5', descricao: 'HONG KONG EXCHANGES AND CLEARING' },
    C6: { id: 'C6', descricao: 'JAKARTA STOCK EXCHANGE' },
    C7: { id: 'C7', descricao: 'KOREA EXCHANGE' },
    C8: { id: 'C8', descricao: 'NATIONAL STOCK EXCHANGE OF INDIA' },
    C9: { id: 'C9', descricao: 'NEW ZEALAND EXCHANGE' },
    E1: { id: 'E1', descricao: 'ATHENS EXCHANGE' },
    E10: { id: 'E10', descricao: 'IRISH STOCK EXCHANGE' },
    E11: { id: 'E11', descricao: 'ISTANBUL STOCK EXCHANGE' },
    E12: { id: 'E12', descricao: 'JSE LIMITED' },
    E13: { id: 'E13', descricao: 'LJUBLJANA STOCK EXCHANGE' },
    E14: { id: 'E14', descricao: 'LONDON STOCK EXCHANGE' },
    E15: { id: 'E15', descricao: 'MALTA STOCK EXCHANGE' },
    E16: { id: 'E16', descricao: 'OMX' },
    E17: { id: 'E17', descricao: 'OSLO BØRS' },
    E18: { id: 'E18', descricao: 'STOCK EXCHANGE OF MAURITIUS' },
    E19: { id: 'E19', descricao: 'SWX SWISS EXCHANGE' },
    E2: { id: 'E2', descricao: 'BME SPANISH EXCHANGES' },
    E20: { id: 'E20', descricao: 'TEL-AVIV STOCK EXCHANGE' },
    E21: { id: 'E21', descricao: 'WARSAW STOCK EXCHANGE' },
    E22: { id: 'E22', descricao: 'WIENER BÖRSE AG' },
    E3: { id: 'E3', descricao: 'BORSA ITALIANA SPA' },
    E4: { id: 'E4', descricao: 'BOURSE DE LUXEMBOURG' },
    E5: { id: 'E5', descricao: 'BUDAPEST STOCK EXCHANGE' },
    E6: { id: 'E6', descricao: 'CAIRO & ALEXANDRIA STOCK EXCHANGES' },
    E7: { id: 'E7', descricao: 'CYPRUS STOCK EXCHANGE' },
    E8: { id: 'E8', descricao: 'DEUTSCHE BÖRSE AG' },
    E9: { id: 'E9', descricao: 'EURONEXT' }
};

module.exports = BOLSA;
